const messages = {
  AIDOO : {
    title: 'Aidoo',
    desc: 'Dispositif pour le contrôle et l\'intégration d\'une unité à détente directe. Options: <br/> · Wi-Fi <br/> · KNX',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6xxxxxx.png',
    articles: {
      AIDOO_WIFI: {
        title: 'Aidoo Contrôle Wi-Fi',
        desc:  'Dispositif de gestion des unités d\'air conditionné ; contrôle à l\'aide de l\'application Airzone Aidoo, connexion Wi-Fi et intégration Modbus',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6WSCxxx.png',
        descResult: 'Contrôlez vos paramètres d\'air conditionné où que vous soyez, grâce à l\'application <b>Airzone Aidoo</b> (disponible sur <a href="https://play.google.com/store/apps/details?id=es.airzone.aidoo" target="_blank" style="color:#007f9b">Android</a> et <a href="https://apps.apple.com/app/airzone-aidoo/id1468065088" target="_blank" style="color:#007f9b">iOS</a>). Compatible avec : ',
        logos: [
          'https://doc.airzone.es/Resources/Images/IMG_logo-Google-Assistant.png',
          'https://doc.airzone.es/Resources/Images/IMG_logo-Alexa.png',
        ],
      },
      AIDOO_KNX: {
        title: 'Aidoo Contrôle KNX',
        desc: 'Dispositif de gestion des unités d\'air conditionné ; contrôle KNX TP-1 et 3 entrées numériques configurables',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6KNXxxx.png',
        descResult: 'Grâce à sa compatibilité avec le logiciel ETS5, vous pouvez facilement configurer Aidoo KNX et l\'intégrer à votre projet. Téléchargez notre <a href="https://doc.airzone.es/producto/Gama_AZ6/Airzone/Aidoo/BBDD_AZAI6KNX.zip" style="color:#007f9b">base de données</a>.',
      }
    },
    include: {
      protocolo: '%{protocolo} %{article}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a> with:',
      accesrories: [
        'Câble de connexion avec l\'unité intérieure.',
        'Vis et adhésif double face pour le montage.',
      ],
    }
  },
  ZONIFIED : {
    title: 'Passerelle pour système multizone',
    desc: 'Passerelle pour le contrôle d\'une unité gainable multizone',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
    articles: {
      COMMUNICATION_GATEWAY: {
        title: 'Passerelles de communication',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
        descResult: '',
      }
    },
    include: {
      pack1: 'Passerelle de communication Airzone - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Passerelle contrôleur 3.0 Airzone - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  MONOZONE : {
    title: 'Module local pour unité individuelle',
    desc: 'Module local filaire/radio pour le contrôle d\'une unité individuelle',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
    articles: {
      WIRED_ZONE_MODULE: {
        title: 'Module local IBPRO32 filaire Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
        descResult: '',
        conection: 'Filaire'
      },
      WIRELESS_ZONE_MODULE: {
        title: 'Module local IBPRO32 radio Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxR.png',
        descResult: '',
        conection: 'Radio'
      }
    },
    include: {
      pack: '%{name} - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Kit module local %{conection} Airzone %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  UNO_SYSTEM : {
    title: 'Pack UNO',
    desc: 'Platine centrale + thermostat filaire/radio pour le contrôle d\'une seule unité individuelle',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PxxxBFCB.png',
    articles: {
      UNO_BLUEFACE_WHITE: {
        title: 'Pack Airzone UNO thermotat Blueface blanc',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCB.png',
        descResult: '',
        type: 'Blueface',
        color: 'Blanc',
        conection: 'Filaire'
      },
      UNO_BLUEFACE_BLACK: {
        title: 'Pack Airzone UNO thermotat Blueface noir',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCN.png',
        descResult: '',
        type: 'Blueface',
        color: 'Noir',
        conection: 'Filaire'
      },
      UNO_THINK_WIRELESS_WHITE: {
        title: 'Pack Airzone UNO thermotat Think radio blanc',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRB.png',
        descResult: '',
        type: 'Think',
        color: 'Blanc',
        conection: 'Radio'
      },
      UNO_THINK_WIRELESS_BLACK: {
        title: 'Pack Airzone UNO thermotat Think radio noir',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRN.png',
        descResult: '',
        type: 'Think',
        color: 'Noir',
        conection: 'Radio'
      },
      UNO_THINK_WIRED_WHITE: {
        title: 'Pack Airzone UNO thermotat Think Filaire blanc',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCB.png',
        descResult: '',
        type: 'Think',
        color: 'Blanc',
        conection: 'Filaire'
      },
      UNO_THINK_WIRED_BLACK: {
        title: 'Pack Airzone UNO thermotat Think Filaire noir',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCN.png',
        descResult: '',
        type: 'Think',
        color: 'Noir',
        conection: 'Filaire'
      }
    },
    include: {
      pack: 'Pack Airzone UNO %{protocolo} thermostat %{type} (<a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>) avec :',
      list1: 'Platine centrale Airzone UNO %{type} %{conection} avec passerelle de communication %{protocolo} intégrée..',
      list2: 'Thermostat Airzone %{type} %{conection} %{color}.',
      list3: 'Câble bus Airzone 10 m.',
      list4: 'Pile bouton CR2450.',
    }
  },
  CompatibilityList: 'Liste de compatibilité',
  SelectBrand: 'Sélectionnez votre fabricant',
  SelectCompatibilityAirzone: 'Sélectionnez votre appareil',
  SelectAtricleAirzone: 'Sélectionnez l\' article Airzone',
  SelectIndoorUnitModel: 'Sélectionnez votre modèle de l\'unité intérieure',
  ResultUnid: 'Pour l\'unité %{unid} (%{manufacturer})',
  ResultYourRefer: 'Votre référence Airzone est :',
  NamePdfFile: 'Airzone-compatibilite-reference',
  SelectInclude: 'Votre sélection inclut : ',
  ZoneSystem: 'Éléments des systèmes de contrôle',
  MonozoneController: 'Contrôleurs monozone',
  List: 'Lister',
  protocolo: {
    DA0: 'Daikin Residential',
    DA1: 'Daikin Sky Air / VRV',
    DA2: 'Daikin Altherma 3',
    FUJ: 'Fujitsu 3 wires',
    FU2: 'Fujitsu UART',
    GRE: 'Gree U-Match R410A',
    GR1: 'Gree U-Match R32',
    HAI: 'Haier',
    HIT: 'Hitachi RPI',
    HI2: 'Hitachi RAD',
    LGE: 'LG',
    MD1: 'Midea V5 protocol',
    MD2: 'Midea V6 protocol',
    MEL: 'Mitsubishi Electric',
    MHI: 'Mitsubishi Heavy',
    PA0: 'Panasonic RAC Domestic',
    PAN: 'Panasonic',
    TOS: 'Toshiba',
    SAM: 'Samsung',
    SA2: 'Samsung Nasa',
    HS1: 'Hisense',
    BAX: 'Baxi',
    BA1: 'Baxi R32',
    F3V: 'Fancoil 3 velocidades',
    FAN: 'Fancoil',
    IFR: 'IR',
    F10: 'Fancoil 0-10V',
    HI3: 'Hitachi Primairy',
    ME2: 'Mitsubishi Electric Ecodan',
  }
};
export default messages;
